# Glossary

This tool and the GTZenda pipeline describe the same things with different
words. Both are listed here, because an alert email speaks GTZenda's language
and this app speaks its own.

| In this tool | In GTZenda | What it means |
| --- | --- | --- |
| Baseline, reference | Last known-good run | The export you trust, to compare against. |
| Latest, candidate | The run under alert | The export you are checking. |
| Source profile | Bot, procurement source | The policy for one source: how records are matched, which fields may be backfilled, when an export is blocked. |
| Run | Parent queue run | One scrape of one source, producing one export file. |
| Record | Child run | One bid or solicitation inside that export. |
| Quarantined | Hold | A run the quality gate refuses to pass. **This tool never releases a hold** — that stays a manual action in the pipeline. |
| Drift | — | Any difference between the two runs, benign or not. |
| Finding | — | One thing the quality engine objected to, on one record and field. |
| Decision | — | Your recorded call on one field of one record, with a reason. Append-only. |
| Recovered export | — | The candidate run with your decisions applied. A stopgap for triage, not a fix: the remedy for systemic loss is re-running the scraper. |

## Two words worth being careful with

**Recurring** does not mean harmless — it means the reference run had the same
duplicate titles, which is why most duplicate-title alerts are false positives.
It is evidence for a judgement, not the judgement.

**Passes the gate** does not mean clean data. Cells still awaiting review and
fields lost systemically are outside what the gate measures, and the Recovery
tab says so alongside the verdict.
